import { InizioPagina } from '@components/servizi-soluzioni/inizio-pagina/inizio-pagina';
import { useIntl } from 'react-intl';
import { Navbar as PageNavbar } from '@components/servizi-soluzioni/navbar/navbar';
import { Container } from '@components/servizi-soluzioni/container/container';
import { LayoutTastiDestra } from '@components/servizi-soluzioni/layout-tasti-destra/layout-tasti-destra';
import { LayoutTastiSinistra } from '@components/servizi-soluzioni/layout-tasti-sinistra/layout-tasti-sinistra';
import { getObjectValue } from '@services/object-extensions';
import { ScrollToTop } from '@components/servizi-soluzioni/scroll-to-top/scroll-to-top';
import cn from 'classnames';
import { useEffect, useMemo, useState } from 'react';
import { TIMEOUT } from '@constants/components/timeout';
import { PageHead } from '../../common/head/page-head';
import { Navbar } from '../../common/navbar/navbar';
import styles from './desktop.module.css';
import { CybersecurityPartners } from '@components/azienda/partners';

export default function ServiziSoluzioniDesktop({
  pages = [],
  mainSectionDescriptions = {},
  mainSectionImageUrl = '',
  mainSectionDarkTheme = false,
  navbarItems = [],
  serviceCategories = [],
  technologyCategories = [],
  isCyberSecurity
}) {
  const intl = useIntl();
  const [navMobileState, setNavMobileState] = useState({ isOpen: false });
  const computedNavbarItems = useMemo(() => {
    return isCyberSecurity
      ? [...navbarItems, { title: 'Partnership', target: 'partners' }]
      : navbarItems;
  }, [isCyberSecurity, navbarItems]);

  useEffect(() => {
    setTimeout(() => {
      const { hash } = window.location;
      window.location.hash = '';
      window.location.hash = hash;
    }, TIMEOUT);
  }, []);

  return (
    <div
      className="snf-lx-components-servizi-soluzioni-desktop-desktop"
      style={{ display: 'contents' }}
    >
      <>
        <PageHead
          title={intl.formatMessage({
            defaultMessage: 'Sistemi Informativi S.r.l. - An IBM company - Servizi e Soluzioni',
            description: 'Servizi e Soluzioni - Page title'
          })}
          description={intl.formatMessage({
            defaultMessage: 'Sistemi Informativi S.r.l. - Servizi e Soluzioni',
            description: 'Servizi e Soluzioni - Page description'
          })}
        />
        <Navbar
          navCssClasses={cn(`${styles.navbarBackground} position-absolute`, {
            noImgBackground: !mainSectionImageUrl
          })}
          navLinkCssClasses={styles.navItem}
          serviceCategories={serviceCategories}
          technologyCategories={technologyCategories}
        />
        <main role="main">
          <Container imageUrl={mainSectionImageUrl} darkTheme={mainSectionDarkTheme}>
            <InizioPagina translations={mainSectionDescriptions} darkTheme={mainSectionDarkTheme} />
            {pages?.length > 0 ? (
              <PageNavbar
                selectedNavItem={navMobileState}
                onNavItemClick={setNavMobileState}
                navbarItems={computedNavbarItems}
              />
            ) : null}
          </Container>
          <div>
            {pages?.map((element, index) => {
              /**
               * Check if the index of the array is even (divisible by 2).
               */
              const isEven = index % 2 === 0;
              return isEven ? (
                <LayoutTastiDestra
                  key={`section-${index + 1}`}
                  urlImage={getObjectValue(element, 'backgroundImage', '')}
                  translations={getObjectValue(element, 'translations', {})}
                  buttons={getObjectValue(element, 'buttons', [])}
                  darkTheme={getObjectValue(element, 'darkTheme', false)}
                  sectionName={getObjectValue(element, 'id', '')}
                  categoryId={getObjectValue(element, 'categoryId', '')}
                />
              ) : (
                <LayoutTastiSinistra
                  key={`section-${index + 1}`}
                  urlImage={getObjectValue(element, 'backgroundImage', '')}
                  translations={getObjectValue(element, 'translations', {})}
                  buttons={getObjectValue(element, 'buttons', [])}
                  darkTheme={getObjectValue(element, 'darkTheme', false)}
                  sectionName={getObjectValue(element, 'id', '')}
                  categoryId={getObjectValue(element, 'categoryId', '')}
                />
              );
            })}
            {isCyberSecurity ? <CybersecurityPartners /> : null}
            {pages?.length > 0 ? (
              <ScrollToTop onClick={() => setNavMobileState({ isOpen: false })} />
            ) : null}
          </div>
        </main>
      </>
    </div>
  );
}
